import React, { useState } from 'react';
import {
  Box,
  Typography,
  Chip,
  Grid,
  Button,
  Collapse,
  Card,
  CardContent,
  Paper,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  ExpandMore,
  ExpandLess,
  // ContactMail,
  // Work,
  // Person,
  // DownloadOutlined,
  AttachFile,
  // Visibility,
  Download,
} from '@mui/icons-material';
import { JobSeekerDetails, Feed } from '@/constants/types';
import { feedService } from '@/services/feed/feedService';
import { useAuth } from '@/hooks';
import { useNavigate } from 'react-router-dom';
import { updateFeedStats, useAppDispatch } from '@/store';

interface JobSeekerCardProps {
  jobSeekerDetails: JobSeekerDetails;
  feedUserId: string;
  feed?: Feed;
  defaultExpanded?: boolean;
}
const experienceLevels:any = {
  entry: "Fresher / Entry Level – 0 to 1 Year",
  junior: "Junior Level – 1 to 3 Years",
  mid: "Mid-Level – 3 to 5 Years",
  senior: "Senior Level – 5 to 8 Years",
  manager: "Managerial Level – 8 to 12 Years",
  head: "Leadership / Head Level – 12 to 18 Years",
  executive: "Director / C-Level – 18+ Years"
};

export const JobSeekerCard: React.FC<JobSeekerCardProps> = ({ jobSeekerDetails, feedUserId, feed, defaultExpanded = false }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(defaultExpanded);
      const dispatch = useAppDispatch();
  
  const isOwnPost = user?.id === feedUserId;
console.log(jobSeekerDetails)
  const formatSalary = (salary?: JobSeekerDetails['currentSalary'] | JobSeekerDetails['expectedSalary']) => {
    if (!salary?.max) return null;
    
    const { max, denomination = 'lakh', currency = 'INR', period = 'yearly' } = salary;
    return `${max} ${denomination} ${currency} per ${period}`;
  };

  const formatJobType = (type: string) => {
    return type.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  const formatExperienceLevel = (level: string) => {
    // return level.charAt(0).toUpperCase() + level.slice(1) + ' Level';
    return experienceLevels[level]
  };

  const formatNoticeType = (notice: string) => {
    return notice === 'immediate' ? 'Immediate' : notice.replace('-', ' ');
  };

  const formatWorkMode = (mode: string) => {
    return mode.charAt(0).toUpperCase() + mode.slice(1);
  };

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const handleDownloadResume = async () => {
    try {
      await feedService.applyForJob(jobSeekerDetails.feedId);
      console.log('Resume download initiated successfully');
      dispatch(updateFeedStats(feed?._id!))
    
  
    } catch (error) {
      console.error('Error downloading resume:', error);
    }finally{
        // Also handle the existing resume download logic
    const resumeData = jobSeekerDetails.resumeId;
      if (typeof resumeData === 'object' && resumeData?.url) {
        window.open(resumeData.url, '_blank', 'noopener,noreferrer');
      }
    }
  };
console.log(jobSeekerDetails)
  return (
    <Box sx={{ mt: 1 }}>
      {/* View Details Button and Stats */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Button
          onClick={toggleExpanded}
          endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
          size="small"
          sx={{
            textTransform: 'none',
            color: '#0a66c2',
            fontWeight: 600,
            px: 0,
            fontSize: '0.875rem',
            '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
          }}
        >
          {expanded ? 'Hide details' : 'View candidate details'}
        </Button>

        {/* Right side - View count and Application count */}
        {feed && isOwnPost && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {/* Application count - Show for jobSeeker feeds */}
            {feed.feedType?.name === 'jobSeeker' && (feed.applicationCount ?? 0) >= 0 && (
                    <Button
                            variant='contained'
                                     onClick={() => {
                                  const params = new URLSearchParams();
                                  if (feed.title) params.append('title', feed.title);
                                  if (feed.feedType?.name) params.append('type', feed.feedType.name);
                                  if (feed.applicationCount !== undefined) params.append('count', feed.applicationCount.toString());
                                  
                                  navigate(`/applications/${feed._id}`);
                                }}
                            >
                          Applications : {feed?.applicationCount && feed?.applicationCount >=100 ? "99+": feed.applicationCount }
                            </Button>
              // <Tooltip title="View profile views">
              //   <Badge
              //     badgeContent={feed.applicationCount}
              //     color="error"
              //     onClick={() => {
              //       const params = new URLSearchParams();
              //       if (feed.title) params.append('title', feed.title);
              //       if (feed.feedType?.name) params.append('type', feed.feedType.name);
              //       if (feed.applicationCount !== undefined) params.append('count', feed.applicationCount.toString());
                    
              //       navigate(`/applications/${feed._id}`);
              //     }}
              //     sx={{
              //       cursor: 'pointer',
              //       '&:hover': {
              //         opacity: 0.8,
              //       },
              //     }}
              //   >
              //     <Insights sx={{ fontSize: 24, color: 'primary.main' }} />
              //   </Badge>
              // </Tooltip>
            )}
            
            {/* View count */}
            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <VisibilityOutlined sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="caption" color="text.secondary">
                {feed.stats?.views || 0}
              </Typography>
            </Box> */}
          </Box>
        )}
      </Box>

      {/* Collapsible Job Seeker Details - LinkedIn Style */}
      <Collapse in={expanded}>
        <Card variant="outlined" sx={{ borderRadius: 2, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
          <CardContent sx={{ p: 2 }}>
            <Grid container spacing={2}>
              {/* Job Type */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Job Type
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {formatJobType(jobSeekerDetails.jobType)}
                </Typography>
              </Grid>

              {/* Designation */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Designation
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {jobSeekerDetails.userId.designation}
                </Typography>
              </Grid>

              {/* Experience */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Experience
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {formatExperienceLevel(jobSeekerDetails.experienceLevel)}
                </Typography>
              </Grid>

              {/* Notice Period */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Notice Period
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {formatNoticeType(jobSeekerDetails.noticeType)}
                </Typography>
              </Grid>

              {/* Work Mode */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Work Mode
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {formatWorkMode(jobSeekerDetails.workMode)}
                </Typography>
              </Grid>

              {/* Current Salary */}
              {jobSeekerDetails.currentSalary?.max && (
                <Grid size={{ xs: 6, sm: 4 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    Current Salary
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#0a66c2' }}>
                    {formatSalary(jobSeekerDetails.currentSalary)}
                  </Typography>
                </Grid>
              )}

              {/* Expected Salary */}
              {jobSeekerDetails.expectedSalary?.max && (
                <Grid size={{ xs: 6, sm: 4 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    Expected Salary
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#057642' }}>
                    {formatSalary(jobSeekerDetails.expectedSalary)}
                  </Typography>
                </Grid>
              )}

              {/* Skills */}
              {jobSeekerDetails.skills && jobSeekerDetails.skills.length > 0 && (
                <Grid size={{ xs: 12, sm: 8 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, display: 'block', mb: 0.5 }}>
                    Skills
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {(jobSeekerDetails?.skills || []).slice(0, 4).map((skill: string, index: number) => (
                      <Chip key={index} label={skill} size="small" sx={{ height: 24, fontSize: '0.75rem', bgcolor: '#e8f5e9', color: '#2e7d32' }} />
                    ))}
                    {(jobSeekerDetails?.skills || []).length > 4 && (
                      <Tooltip
                        title={
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            {(jobSeekerDetails?.skills || []).slice(4).map((skill: string, index: number) => (
                              <Typography key={index} variant="body2" sx={{ color: 'white' }}>{skill}</Typography>
                            ))}
                          </Box>
                        }
                      >
                        <Chip label={`+${(jobSeekerDetails?.skills || []).length - 4}`} size="small" sx={{ height: 24, fontSize: '0.75rem', bgcolor: '#0a66c2', color: 'white' }} />
                      </Tooltip>
                    )}
                  </Box>
                </Grid>
              )}

              {/* Preferred Locations */}
              {jobSeekerDetails.location && jobSeekerDetails.location.length > 0 && (
                <Grid size={{ xs: 12, sm: 4 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, display: 'block', mb: 0.5 }}>
                    Locations
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {(jobSeekerDetails?.location || []).slice(0, 2).map((location: string, index: number) => (
                      <Chip key={index} label={location} size="small" sx={{ height: 24, fontSize: '0.75rem' }} />
                    ))}
                    {(jobSeekerDetails?.location || []).length > 2 && (
                      <Tooltip
                        title={
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            {(jobSeekerDetails?.location || []).slice(2).map((location: string, index: number) => (
                              <Typography key={index} variant="body2" sx={{ color: 'white' }}>{location}</Typography>
                            ))}
                          </Box>
                        }
                      >
                        <Chip label={`+${(jobSeekerDetails?.location || []).length - 2}`} size="small" sx={{ height: 24, fontSize: '0.75rem', bgcolor: '#0a66c2', color: 'white' }} />
                      </Tooltip>
                    )}
                  </Box>
                </Grid>
              )}

              {/* Resume - LinkedIn Style */}
              {!isOwnPost && jobSeekerDetails.resumeId && (
                <Grid size={{ xs: 12 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 1.5,
                      borderRadius: 2,
                      bgcolor: 'background.paper',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5,
                      cursor: 'pointer',
                      '&:hover': { bgcolor: 'action.hover', borderColor: '#0a66c2' },
                    }}
                    onClick={handleDownloadResume}
                  >
                    <Box sx={{ bgcolor: '#e8f5e9', borderRadius: 1, p: 1, display: 'flex' }}>
                      <AttachFile sx={{ color: '#2e7d32' }} />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography variant="body2" fontWeight="600" noWrap>
                        {typeof jobSeekerDetails.resumeId === 'object' && jobSeekerDetails.resumeId?.originalName
                          ? jobSeekerDetails.resumeId.originalName
                          : 'Resume.pdf'}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Click to download resume
                      </Typography>
                    </Box>
                    <IconButton size="small" sx={{ bgcolor: '#0a66c2', color: 'white', '&:hover': { bgcolor: '#004182' } }}>
                      <Download fontSize="small" />
                    </IconButton>
                  </Paper>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Collapse>
    </Box>
  );
};